






































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { InvoiceCollectionTypeInAdmin } from '@/modules/invoice/models/invoice-collection.model'
import AdminInvoiceTableRow from '@/modules/invoice/components/admin/table/AdminInvoiceTableRow.vue'
import { getInvoiceColumns } from '@/modules/invoice/models/columns/invoice.column'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import AdminInvoiceCreateButton from '@/modules/invoice/components/admin/AdminInvoiceCreateButton.vue'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست فاکتورها'
  },
  metaInfo: {
    title: 'لیست فاکتورها'
  },
  components: {
    AdminInvoiceCreateButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  @ProvideReactive()
  @Prop() invoices: InvoiceCollectionTypeInAdmin
  private rowComponent = AdminInvoiceTableRow
  private columns = getInvoiceColumns(true)

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت',
      key: 'statuses',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.invoices.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'مدل فاکتور',
      key: 'model_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.invoices.model_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع فاکتور',
      key: 'person_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.invoices.person_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Custom,
      key: 'user',
      title: 'کاربران',
      typeMode: false,
      component: AdminUserSearchFilter
    }),
    new Filter({
      type: FilterTypes.DateRange,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ],
      title: 'تاریخ پرداخت',
      holder: 'انتخاب کنید',
      keys: {
        from: 'paid_at_from',
        to: 'paid_at_to'
      }
    }),
    new Filter({
      type: FilterTypes.DateRange,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ],
      title: 'تاریخ سررسید',
      holder: 'انتخاب کنید',
      keys: {
        from: 'due_date_from',
        to: 'due_date_to'
      }
    })
  ]

  protected get model(): any {
    return this.invoices
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
